"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Wish = function Wish(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.463,8.653c-0.627,0-1.211,0.511-1.297,1.135l-0.637,4.647c-0.07,0.506-0.313,0.945-0.727,1.317 c-0.415,0.372-0.882,0.558-1.4,0.558c-0.504,0-0.913-0.182-1.224-0.547c-0.313-0.365-0.433-0.808-0.361-1.329l0.385-2.82 c0.012-0.563-0.411-1.003-0.993-1.003h-1.525c-0.582,0-1.127,0.44-1.27,1.003l-0.397,2.82c-0.072,0.521-0.315,0.964-0.729,1.329 c-0.414,0.365-0.872,0.547-1.376,0.547c-0.504,0-0.915-0.186-1.234-0.558c-0.319-0.372-0.443-0.811-0.373-1.317l0.854-6.166 c0.091-0.6-0.265-1.228-0.808-1.482c0,0-6.43-2.68-6.849-2.853C1.077,3.76,0.596,4.15,0.432,4.8L0.039,6.351 C-0.126,7,0.246,7.739,0.863,7.992l4.31,1.784l-0.646,4.659c-0.217,1.563,0.15,2.899,1.1,4.008c0.95,1.11,2.203,1.664,3.76,1.664 c1.437,0,2.748-0.483,3.934-1.451c0.947,0.968,2.133,1.451,3.555,1.451c1.556,0,2.962-0.554,4.22-1.664 c1.257-1.109,1.995-2.446,2.211-4.008c0,0,0.675-4.917,0.688-5.003c0.059-0.429-0.406-0.779-1.032-0.779L21.463,8.653L21.463,8.653 z"
  }));
};

Wish.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Wish.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Wish;
exports["default"] = _default;